<template>
    <div class="bannerSwiper cp-bannerSwiper" v-if="swiperData.length > 0">
        <!-- 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个ref属性 -->
        <component :is="swiper" v-if="loadReady" :options="swiperOption" ref="mySwiperA">
            <!-- 幻灯内容 -->
            <component :is="swiperSlide" v-for="(item, index) in swiperData" :key="index" v-if="loadReady">
                <div class="swiperCont">
                    <span v-if="item.isSpike" class="promotion-brand"></span>
                    <img v-bind:src="item.introPicture">
                    <!--<div class="title" v-if="!!item.name"></div>-->
                    <!--<div class="titleText" v-if="!!item.name">{{ item.name}}</div>-->
                </div>
            </component>
            <!-- 以下控件元素均为可选（使用具名slot来确定并应用一些操作控件元素） -->
            <div class="swiper-pagination" slot="pagination" v-show="swiperData.length > 1"></div>
        </component>
    </div>
</template>

<script>
    let vm = null;
    import {mapState} from 'vuex';
    // import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'


    export default {
        name: 'indexSwiper',
        /*components: {
            swiper,
            swiperSlide
        },*/
        computed: {
            ...mapState([
                'channelId',
            ]),
        },
        props: ['swiperData'],
        data() {
            return {
                swiper: null,
                swiperSlide: null,
                loadReady: false,
                swiperOption: {
                    autoplay: 3000,
                    autoplayDisableOnInteraction: false,
                    slidesPerView: 1.12,
                    initialSlide : 0,
                    // loopAdditionalSlides : 3,
                    loop : true,
                    onClick:function(e){
                        vm.swiperClick(e.realIndex)
                    },
                    centeredSlides: true,
                    spaceBetween: 5,
                    observer: true,
                    observeParents:true,
                    pagination : '.swiper-pagination',
                    paginationType : 'fraction'      
                }
            }
        },
        methods: {
            swiperClick(index) {
                let item = this.swiperData[index]
                this.$emit('swiperClick', item, index);
            }
        },
        created() {
            vm = this;
        },
        // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
        mounted() {
            domReadyPr.then(() => import('vue-awesome-swiper')).then(({swiper, swiperSlide}) => {
                this.loadReady = true;
                this.swiper = swiper;
                this.swiperSlide = swiperSlide;
            });
        }
    }
</script>

<style lang="scss">
    $font-size-base: 75; // Base on 750px;
    @function topx($rem) {
        @return $rem/$font-size-base;
    }
    .cp-bannerSwiper {
        .swiper-wrapper {
            height: 0;
            width: 100%;
            padding-bottom: 52%;
        }
        .swiper-pagination{
            position: absolute;
            width: topx(75rem);
            height: topx(30rem);
            right: topx(60rem) !important;
            bottom: topx(30rem);
            color: #fff;
            background: #333;
            background:rgba(0, 0, 0, .3);
            border-radius: topx(14.5rem);
            line-height: topx(30rem);
        }
        .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
            right: topx(60rem) !important;
            left: none !important;
        }
        .swiperCont {
            position: absolute;
            top: 0;
            height: 0;
            width: topx(670rem);
            padding-bottom: 56%;
            border-radius: topx(26rem);
            overflow: hidden;
            .promotion-brand {
                position: absolute;
                z-index: 2;
                top: topx(20rem);
                left: topx(20rem);
                width: topx(50rem);
                height: topx(50rem);
                background: url('../../../assets/promotion/icon-brand.png') no-repeat;
                background-size: cover;
            }
            img {
                position: absolute;
                top: 50%;
                width: 100%;
                transform: translate(0, -50%);
                border-radius: topx(26rem);
            }
            .title {
                position: absolute;
                height: 90px * 0.5;
                bottom: 0;
                right: 0;
                background: #000;
                opacity: .5;
                font-size: 36px * 0.5;
                color: #FFFFFF;
                line-height: 90px * 0.5;
                padding-left: 30px * 0.5;
            }
            .titleText {
                position: absolute;
                height: 90px * 0.5;
                bottom: 0;
                right: 0;
                font-size: 36px * 0.5;
                color: #FFFFFF;
                line-height: 90px * 0.5;
                padding-left: 30px * 0.5;
            }
        }
        .swiper-slide {
            width: 100%;
        }
        .swiper-slide-next {
            .swiperCont{
                width: 89.11%;
                height: 89.11%;
            }
        } 
        .swiper-slide-prev {
            .swiperCont{
                width: 89.11%;
                height: 89.11%;
                right: 0;
            }
        }
        .swiper-slide-active{
            box-shadow: 0 0 topx(20rem) 0 rgba(188,188,188,0.50);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/show/index/bannerSwiper.vue